import seoConfig from '@core/config/seo'
import { i18n } from '@core/i18n/i18n'

const { separator } = seoConfig

export const formatPageTitle = (title: string) =>
  `${title} ${separator} ${i18n.t('seo.webTitle')}`
